module.exports = __webpack_public_path__ + "img/9788971847763.e6016552.jpg";